import axios from 'axios'
import { set } from 'lodash'

const userModule = {
    state: {
        groups: null,
        user_data: null,
        subscribes: null,
        limits: null,
        auth: window.auth,
        apiUser: window.apiUser,
        userName: window.userName,
        apiSession: window.apiSession
    },
    mutations: {
        setStateObject(state, { name, value }) {
            set(state, name, value)
        }
    },
    actions: {
        
        authAPI({ dispatch }, { data, method }) {
            
            return axios({
                baseURL: `${process.env.API_AUTH}/v3`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: { data, method }
            }).then(resp => {
                if(resp.status === 200) {
                    return resp
                }
            }).catch(err => {
                console.log(err)
                dispatch('showErrorPopUp', `Ошибка авторизации ${err.message}`)
            })
        },
        getUserInfo({ commit, dispatch }){

            return dispatch('authAPI', {
                method: 'user',
                data: {
                    sid: window.apiSession,
                    get_subscr: true
                }
            }).then(e => {
                switch(e.data.code){
                    case - 1:
                        dispatch("showErrorPopUp", "неизвестная ошибка")
                        break;
                    case 1:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 1")
                        break;
                    case 2:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 2")
                        break;
                    case 3:
                        dispatch("showErrorPopUp", "неверный пароль")
                        break;
                    case 4:
                        dispatch("showErrorPopUp", "неверный пароль")
                        break;
                    case 5:
                        dispatch("showErrorPopUp", "доступ запрещён")
                        break;
                    case 6:
                        dispatch("showErrorPopUp", "превышен лимит сессий")
                        break;
                    case 7:
                        // dispatch("showErrorPopUp", "Ваш сеанс был завершён. Авторизуйтесь.")
                        break;
                    case 8:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 8")
                        break;
                    case 9:
                        dispatch("showErrorPopUp", "превышен лимит запросов")
                        break;
                    case 10:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 10")
                        break;
                    case 11:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 11")
                        break;
                    case 12:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 12")
                        break;
                    case 13:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 13")
                        break;
                    case 14:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 14")
                        break;
                    case 15:
                        dispatch("showErrorPopUp", "отсутствует действующая подписка")
                        break;
                    case 16:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 16")
                        break;
                    case 17:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 17")
                        break;
                    case 18:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 18")
                        break;
                    case 19:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 19")
                        break;
                    case 20:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 20")
                        break;
                    case 21:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 21")
                        break;
                    case 22:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 22")
                        break;
                    case 23:
                        dispatch("showErrorPopUp", "Ошибка авторизации. Код: 23")
                        break;
                }
                            
                if(e.data?.data?.groups){
                    commit('setStateObject', { name: 'groups', value: e.data.data.groups })
                }
                if(e.data?.data?.subscribes ){
                    commit('setStateObject', { name: 'subscribes', value: e.data.data.subscribes })
                }
                if(e.data?.data?.limits){
                    commit('setStateObject', { name: 'limits', value: e.data.data.limits })
                }
                
                commit('setStateObject', { name: 'user_data', value: {
                    user_id: e.data.data.user_id,
                    user_name: e.data.data.user_name,
                    user_login: e.data.data.user_login,
                    user_contact_name: e.data.data.user_contact_name,
                    user_bank_inn: e.data.data.user_bank_inn,
                    user_phone: e.data.data.user_phone,
                    user_email: e.data.data.user_email,
                    user_status: e.data.data.user_status,
                    monitoring_limit: e.data.data.monitoring_limit,
                    fl_online: e.data.data.fl_online,
                }})
            })
        },
        getGroupInfo({commit, dispatch}, payload =[]){
            
            return dispatch('authAPI', {
                method: 'group_members',
                data: {
                    sid: window.apiSession,
                    flat: true,
                    groups: payload,
                    product_code: process.env.PRODUCT_CODE
                }
            }).then(e => {
                return e.data.data
            })
            
        }
    }
}

export default userModule